import { useAtomValue } from 'jotai/react'
import { useEffect } from 'react'
import { themeAtom } from '../atoms/theme'

export const useThemeSync = () => {
  const theme = useAtomValue(themeAtom)

  useEffect(() => {
    document.documentElement.classList.remove('light', 'dark')
    document.documentElement.classList.add(theme)
    // Keep the UA colour scheme (form controls, scrollbars) on the applied
    // theme; a boot script may have set it inline before the bundle loaded.
    document.documentElement.style.colorScheme = theme
  }, [theme])
}
